import { TextField } from '@material-ui/core'
import {
  Autocomplete,
  AutocompleteChangeReason,
  AutocompleteCloseReason,
  AutocompleteProps,
  AutocompleteRenderOptionState
} from '@material-ui/lab/'
import React, { ChangeEvent, useState } from 'react'
import { useField, useForm } from 'react-final-form'

interface AutoCompleteProps<T extends Value<any>>
  extends Omit<AutocompleteProps<T, true, false, false>, 'renderInput'> {
  name: string
  label: string
  renderOptions?: (params: AutocompleteRenderOptionState) => React.ReactNode
}

interface Value<T> {
  label: string
  value: T
}

export const RFFMultipleAutocomplete = <T extends Value<any>>({
  name,
  label,
  clearText = 'Limpar',
  closeText = 'Fechar',
  loadingText = 'Carregando...',
  noOptionsText = 'Sem opções',
  openText = 'Abrir',
  selectOnFocus = true,
  clearOnBlur = true,
  handleHomeEndKeys = true,
  options,
  renderOption,
  ...props
}: AutoCompleteProps<T>) => {
  const [open, setOpen] = useState(false)
  const { input } = useField(name)
  const form = useForm()

  const value = typeof input.value === 'string' ? null : input.value

  const handleChange = (
    e: ChangeEvent<{}>,
    value: T[],
    reason: AutocompleteChangeReason
  ) => {
    props.onChange?.(e, value, reason)

    form.getFieldState(name)?.change(value)
  }

  const handleClose = (
    _: React.ChangeEvent<{}>,
    reason: AutocompleteCloseReason
  ) => {
    if (!['select-option', 'remove-option'].includes(reason)) {
      setOpen(false)
    }
  }

  return (
    <Autocomplete
      multiple
      {...props}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={handleClose}
      onChange={handleChange}
      onBlur={input.onBlur}
      clearText={clearText}
      closeText={closeText}
      loadingText={loadingText}
      noOptionsText={noOptionsText}
      openText={openText}
      options={options}
      getOptionSelected={(option, value) => option.label === value?.label}
      getOptionLabel={option => option.label}
      value={value ?? []}
      selectOnFocus={selectOnFocus}
      clearOnBlur={clearOnBlur}
      handleHomeEndKeys={handleHomeEndKeys}
      renderInput={params => (
        <TextField {...params} variant="outlined" label={label} />
      )}
      renderOption={renderOption}
    />
  )
}
